import ServiceAccountsTab from './ServiceAccountsTab';
import './ServiceAccountsTab.scss';

export default ServiceAccountsTab;
